import OptionTile from './OptionTile.jsx';
import { useState, useRef, useEffect, useContext } from 'react';
import { EmbedSiteShortContext } from '../App.js';
import '../assets/scss/components/categorypanel.scss';
import * as API from '../api/Service.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import * as Utils from '../common/Utils.js';
import { useErrorBoundary } from "react-error-boundary";

export default function CategoryPanel(props)
{
    //console.log("CategoryPanel " + props.categoryPanelModel.name, JSON.parse(JSON.stringify(props, undefined, 2)));

    const site = useContext(EmbedSiteShortContext);

    // on first load there are no options - this will be detected by this component itself and make an API call to fetch the options and then re-render

    const noneSelectedText = "None Selected";

    //#region Build up selected product names and IDs + compatible/incompatible options lists

    let chosenOptionName = "";
    let optionSelected = false;

    // TODO: figure out why multiple renders are happening - using this as workaround for now?
    let [fetchingCategoryData, setFetchingCategoryData] = useState(false);
    let [showSearchBox, setShowSearchBox] = useState(false);
    let [searchInputvalue, setSearchInputvalue] = useState('');
    let [sortByPrice, setSortByPrice] = useState('');
    const searchInputRef = useRef(null);

    let categoryPanelModelData = props.categoryPanelModel;
    
    let categoryPanelModelDataOptions = categoryPanelModelData.options || [];
    
    // set changing category's isUpdated flag to true to keep rendering disabled options if in middle of updating an option - to prevent UI elements rendering differently
    if (props.categoryTouched.id === categoryPanelModelData.id && categoryPanelModelData.isUpdated === undefined && fetchingCategoryData)
    {
        categoryPanelModelData.isUpdated = true;
    }

    // incompatible items count is set as undefined in one render cycle causing layout shift despite the number not changing
    // using persistedIncompatibleItemsCount to prevent this
    let [persistedIncompatibleItemsCount, setPersistedIncompatibleItemsCount] = useState(0);

    if (categoryPanelModelData.incompatibleItemCount === 0 && persistedIncompatibleItemsCount !== 0)
    {
        setPersistedIncompatibleItemsCount(0);
    }
    else if (categoryPanelModelData.incompatibleItemCount > 0 && persistedIncompatibleItemsCount === 0)
    {
        setPersistedIncompatibleItemsCount(categoryPanelModelData.incompatibleItemCount);
    }

    let compatibleOptionsList = [];
    let incompatibleOptionsList = [];

    if (categoryPanelModelDataOptions)
    {
        for (let i = 0; i < categoryPanelModelDataOptions.length; i++)
        {
            if (categoryPanelModelDataOptions[i].isSelected)
            {
                optionSelected = true;

                if (!categoryPanelModelData.allowMultipleSelection)
                {
                    chosenOptionName = categoryPanelModelDataOptions[i].productName

                    if (categoryPanelModelData.allowQuantitySelection)
                        chosenOptionName += " x " + categoryPanelModelDataOptions[i].selectedQuantity;
                }
                else
                {
                    chosenOptionName += categoryPanelModelDataOptions[i].productName;

                    if (categoryPanelModelData.allowQuantitySelection)
                        chosenOptionName += " x " + categoryPanelModelDataOptions[i].selectedQuantity + ", ";
                    else
                        chosenOptionName += ", ";
                }
            }

            // check against search term
            let searchHit = false;
            if ( searchInputvalue.length === 0 || (searchInputvalue.length > 0 && categoryPanelModelDataOptions[i].searchString && categoryPanelModelDataOptions[i].searchString.includes(searchInputvalue.toLowerCase())) )
            {
                searchHit = true;
            }

            // if incompatibility severity not set or just a warning (e.g. high power usage etc. i.e. not 2 - fully incompatible) then assume compatible
            if ( (!categoryPanelModelDataOptions[i].severity || categoryPanelModelDataOptions[i].severity !== 2) && searchHit )
            {
                compatibleOptionsList.push(categoryPanelModelDataOptions[i]);
            }
            else if (searchHit)
            {
                incompatibleOptionsList.push(categoryPanelModelDataOptions[i]);
            }
        }

        if (searchInputvalue.length > 0)
        {
            categoryPanelModelData.incompatibleItemCount = incompatibleOptionsList.length;

            if (persistedIncompatibleItemsCount !== incompatibleOptionsList.length)
            {
                setPersistedIncompatibleItemsCount(incompatibleOptionsList.length);
            }
        }
    }

    // hack off trailing comma for multi-select, show none selected if none selected, or leave as single selected option
    if (chosenOptionName !== "" && categoryPanelModelData.allowMultipleSelection)
    {
        chosenOptionName = chosenOptionName.slice(0, -2);
    }
    else if (!categoryPanelModelData.isUpdated)
    {
        let name = props.getSelectedOptionName(categoryPanelModelData.id);

        if (name)
            chosenOptionName = name;
        else if (chosenOptionName === "" || chosenOptionName === null)
            chosenOptionName = noneSelectedText;
    }
    else if (!optionSelected)
    {
        chosenOptionName = noneSelectedText;
    }

    // set selected option name in MainContent assuming category model is up to date
    // if (!categoryPanelModelData.isUpdated === undefined)
        props.setSelectedOptionName(categoryPanelModelData.id, chosenOptionName);

    //#endregion Build up selected product names and IDs  + compatible/incompatible options lists

    // add liamo
    // if showing initial no. of options sort by sort order, else by price
    if (sortByPrice !== '')
    {
        compatibleOptionsList = compatibleOptionsList.sort((a, b) => { return sortByPrice === 'asc' ? a.grossPrice - b.grossPrice : b.grossPrice - a.grossPrice; });
    }
    else
    {
        compatibleOptionsList = compatibleOptionsList.sort((a, b) => (a.grossPrice > b.grossPrice) ? 1 : ((b.grossPrice > a.grossPrice) ? -1 : 0));
    }
    // add liamo

    let optionsList = compatibleOptionsList.slice(0, compatibleOptionsList.length)

    //#region Set up welcome modal

    // DEPRECATED - Spinner heights were here (22/05/2025)

    const { isExpress, categoryPanelModel, setShowWelcomeModal } = props;

    useEffect(() =>
    {
        const setWelcomeCookie = () => {
            document.cookie = "seenWelcomeModal=True;path=/;";
        }

        // show welcome modal once
        if (!isExpress) 
        {
            var hasWelcomeCookie = (document.cookie.match(/^(.*;)?\s*seenWelcomeModal\s*=\s*[^;]+(.*)?$/) != null);
            if (!hasWelcomeCookie) 
            {
                setShowWelcomeModal(true);
                setWelcomeCookie();
            }
        }
    }, [isExpress, categoryPanelModel, setShowWelcomeModal]);

    //#endregion Set up height of spinners

    //#region Refetch Category Model and update viewModel
    // ...if Category marked as dirty during a different operation/interaction on the UI

    let url = "/category?buildid=" + props.buildID + 
                       "&categoryid=" + categoryPanelModelData.id + 
                       "&inexpertmode=" + props.isExpertMode + 
                       "&showIncompatible=" + (props.showIncompatible ? props.showIncompatible : "false") + 
                       "&initialOptionProductID=" + (categoryPanelModelData.initialOptionProductID ? categoryPanelModelData.initialOptionProductID : "-1");

    // this is set in stone on component load so changing state will not affect the endpoint used - can only be changed via changing props at parent level
    const fetchCategoryRefetch = API.useRefetchQuery("FetchCategory" + categoryPanelModelData.id, url, 1);

    const { showBoundary } = useErrorBoundary();

    // this will happen once as returned value will ensure isUpdated is true
    if ((!fetchingCategoryData && props.isViewModelUpdated && !categoryPanelModelData.isUpdated))
    {
        //console.log("not updated so call fetchCategoryRefetch url: ", JSON.parse(JSON.stringify(url)));
        setFetchingCategoryData(true);

        fetchCategoryRefetch()
            .then((response) =>
            {
                if (response?.data?.errors && Object.keys(response.data.errors).length > 0)
                {
                    throw new Error(JSON.stringify(response));
                }

                return response.data;
            })
            .then((refetchData) =>
            {
                props.handleCategoryFetched(refetchData.category);
                setFetchingCategoryData(false);
                
                return true; // call finished
            })
            .catch((error) =>
            {
                //console.log("Cat Panel fetchCategoryRefetch error: ", JSON.parse(JSON.stringify(error)));
                showBoundary(error);
            });
    }
    //console.log("fetchingCategoryData: " + JSON.parse(JSON.stringify(fetchingCategoryData)) + "  props.isViewModelUpdated: " + JSON.parse(JSON.stringify(props.isViewModelUpdated)) + "  categoryPanelModelData.isUpdated: " + JSON.parse(JSON.stringify(!categoryPanelModelData.isUpdated ? "undefined" : categoryPanelModelData.isUpdated)));

    //#endregion Refetch Category Model and update Build 

    //#region Event Handlers

    const handleOptionSelected = (optionID, quantity, isQuantityChange, isSelected, isIncompatible) =>
    {
        // don't allow users to deselect options unless the category allows multiple selections
        if (!props.isExpertMode && !isSelected && !categoryPanelModelData.allowMultipleSelection && categoryPanelModelData.id !== 436) // 436 - Antivirus
            return false;

        props.updateCategory(optionID, categoryPanelModelData, quantity, isQuantityChange, isSelected, isIncompatible);

        return true;
    }

    const handleExpertModeClick = () =>
    {
        props.showExpertModeModal();
    }

    const handleShowIncompatibleOptions = () =>
    {
        props.handleFetchIncompatibleOptions(categoryPanelModelData.id);
    }

    const handleHideIncompatibleOptions = () =>
    {
        props.handleFetchCompatibleOptions(categoryPanelModelData.id);
    }

    const handleOnKeyUp = (event) =>
    {
        setSearchInputvalue(event.target.value);

        //if (event.key === 'Enter')
        //{
        //    setSearchTerm(true);
        //}
    }

    const handleSearchClick = () => 
    {
        if (!showSearchBox) 
        {
            setShowSearchBox(true);
        } 
        //else
        //{
        //    setSearchTerm(true);
        //}
    }
    const handlePriceSortClick = (event) =>
    {
        let sortByPrice = event.target.value;
        setSortByPrice(sortByPrice);
    }

    const handleToggleCategory = () =>
    {
        props.handleToggleCategory(categoryPanelModelData.id,  props.isExpandedCategoryName, headerRef);
    }

    // custom accordion stuff
    const contentRef = useRef(null);
    const headerRef = useRef(null);

    useEffect(() => {
        
        const el = contentRef.current;
        
        if (!el) return;

        let resizeObserver = null;

        if (props.isOpen) {
            
            el.style.maxHeight = el.scrollHeight + 'px';

            // use resizeObserver to recalc height as tiles are rendered
            resizeObserver = new ResizeObserver(() => {
                const height = el.scrollHeight + 'px';

                // Avoid constant updates if height didn't change
                if (el.style.maxHeight !== height) {
                    // Schedule after current resize cycle to avoid Firefox warning
                    setTimeout(() => {
                        el.style.maxHeight = height;
                    }, 0);
                }
            });

            resizeObserver.observe(el);
        } else {
            el.style.maxHeight = '0px';
        }

        return () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };

    }, [props.isOpen, props.showIncompatible, categoryPanelModelData.isUpdated]);

    //#endregion Event Handlers

    //#region Scroll To Category

    if (categoryPanelModelData.isUpdated) {
        if (props.scrollToItem.current != null
            && props.requiredLoadedCategories != null
            && optionsList.length === 0
            && categoryPanelModelData.name) {
            var categoryIndex = props.requiredLoadedCategories.current.findIndex(x => x.name === categoryPanelModelData.name);
            if (categoryIndex > -1) {
                props.requiredLoadedCategories.current.splice(categoryIndex, 1);
            }
        }
    }

    if (props.scrollToItem.current != null) {
        var category = props.categoryPanelModel;
        var chosenCategory = props.scrollToItem.current;

        if (category.id === chosenCategory.rightPossibleCategory) {
            props.categoryMatchedName.current = category.name;
        }

        if (props.categoryMatchedName.current != null) {
            var categoryElement = document.getElementById(props.categoryMatchedName.current);

            if (categoryElement != null && props.imageLoaded.current) {
                categoryElement.scrollIntoView({ behavior: 'smooth' });
                props.scrollToItem.current = null;
                props.categoryMatchedName.current = null;
            }
        }
    }

    //#endregion Scroll To Category

    useEffect(() => {

        if (showSearchBox) {
          searchInputRef.current.focus();
        }

    }, [showSearchBox]);

    function getRowColsClass(site, displayType) 
    {
        if (site === "chillblast") 
        {
            return displayType === 1
                ? " flush-cols row-cols-1"
                : " flush-cols g-3 row-cols-2 row-cols-sm-3";
        } 
        else 
        {
            return displayType === 1
                ? " g-2 row-cols-1 row-cols-lg-2"
                : " g-2 row-cols-2 row-cols-sm-3 row-cols-xxl-4";
        }
    }

    //console.log("CategoryPanel end " + props.categoryPanelModel.name, JSON.parse(JSON.stringify(props, undefined, 2)));

    return (
        <> 
            <div id={categoryPanelModelData.name.replace(/\s+/g, "-")} className={"accordion-item bg-transparent border-0" + (site === 'chillblast' ? " border-secondary " : "") + (!props.isLastItem ? " border border-bottom" : " mb-3")} >

                { /* ----- Category name and badge ----- */ }
                <div className={"accordion-header d-flex justify-content-between align-items-center custom-bg-dark" + (props.isExpanded ? " accordion-header-expanded" : "")}>
                    <button ref={headerRef} className={"accordion-button d-flex align-items-center bg-transparent shadow-none px-0 py-3-5" + (props.isOpen ? " collapsed" : "")} type="button" aria-expanded="false" aria-controls={"collapse" + categoryPanelModelData.name.replace(/\s+/g, "-")}
                            onClick={ handleToggleCategory }>
                        <h1 className="cp-category-name custom-color-light mb-0 me-2">{categoryPanelModelData.name}</h1>
                        {
                            props.categoryInfo.isRequired
                            ?
                                <span className="required-badge badge rounded-pill bg-danger ms-auto">Required!</span>
                            :
                            props.categoryInfo.isIntegrated
                            ?
                                <span className="igpu-badge badge rounded-pill text-dark ms-auto">Integrated<input className="form-check-input cp-checkbox igpu-badge-checbox mt-0 border-0" type="checkbox" value="" id="flexCheckDefault" checked readOnly /></span>
                            :
                                // ----- Chosen option name / integrated ----- 
                                <h3 className="cp-option-name text-end ms-auto mb-0 custom-color-light">
                                    {props.categoryInfo.isIntegrated ? "Integrated " + categoryPanelModelData.name : chosenOptionName}
                                </h3>
                        }
                    </button>
                </div>

                <div ref={contentRef} id={"collapse" + categoryPanelModelData.name.replace(/\s+/g, "-")} className="accordion-content" style={{
                        overflow: 'hidden',
                        transition: 'max-height 0.4s ease',
                        maxHeight: '0px',
                        }}>
                    <div  className="accordion-body pt-0 px-0" >
                        { /* ----- Sort and search ----- */ }
                        <div className="accordion-filters d-flex gap-2 flex-wrap mb-3">
                            <div className="sortby-dropdown dropdown">
                                <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Sort By: <span className="fw-bold me-2">Price ({sortByPrice === 'desc' ? "highest" : "lowest"} first)</span>
                                </button>
                                <ul className="dropdown-menu">
                                    <li><button className="dropdown-item" type="button" onClick={ handlePriceSortClick } value="asc" >Price (lowest first)</button></li>
                                    <li><button className="dropdown-item" type="button" onClick={ handlePriceSortClick } value="desc" >Price (highest first)</button></li>
                                </ul>
                            </div>

                            <span className="search-pill d-inline-flex rounded-pill">
                                <div className="cp-search-container is-visible w-100">
                                    <input type="text" placeholder="Search..." 
                                            className="cp-search border-0 bg-transparent mt-1 ms-1"
                                            onKeyUp={ handleOnKeyUp }
                                            />
                                </div>
                                <FontAwesomeIcon icon={icon({ name: 'magnifying-glass', style: 'solid' })} 
                                                    className="search-icon my-auto me-2 ms-1" 
                                                    />
                            </span>
                        </div>


                        { /* ----- Info text ----- */ }
                        {
                            categoryPanelModelData.description
                            &&
                                <div className="text-muted mt-1 alert alert-light mt-2 cp-alert pb-0" dangerouslySetInnerHTML={{ __html: categoryPanelModelData.description }} ></div>
                        }

                        {
                            (categoryPanelModelData.allowMultipleSelection && categoryPanelModelData.id !== 473)
                            &&
                                <span className="text-muted d-inline-block mb-3" style={{ fontSize: "16px" }}>Multi-select available</span>
                        }

                        {/* ----- Options ----- */}
                        <div className={optionsList.length > 0 && categoryPanelModelData.isUpdated ? "mb-3 overflow-hidden" : ""}>
                            {
                                // ----- WAITING FOR OPTIONS ----- 

                                // If the category is dirty, show spinner and wait for async call to bring in options
                                !categoryPanelModelData.isUpdated && props.categoryTouched.id !== categoryPanelModelData.id
                                ?
                                    <div className="d-flex justify-content-center align-items-center mt-3" role="status" style={{ height: "5.625rem" }}>
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                :
                                // ----- NO OPTIONS ----- 

                                // If the category has fetched all possible options but there are none, show message
                                categoryPanelModelData.isUpdated && optionsList.length === 0 && persistedIncompatibleItemsCount === 0
                                ?
                                    <div className="d-flex justify-content-center align-items-center" role="status">
                                        <span className="no-options-text fst-italic text-muted mt-3">No options available. { !props.isExpertMode ? <span className="no-options-text text-decoration-underline" style={{ cursor: 'pointer' }} onClick={handleExpertModeClick}>Enable expert mode?</span> : null }</span>
                                    </div>
                                :
                                    // ----- COMPATIBLE OPTIONS -----
                                    <div className={"row" + getRowColsClass(site, categoryPanelModelData.optionDisplayType)}>
                                        {
                                            optionsList.length > 0
                                            &&
                                                optionsList.map(optionModel =>
                                                    <div key={"div_" + optionModel.optionProductID} className={"col ot-container" + (!categoryPanelModelData.isUpdated ? " disabled" : "")} data-sku={optionModel.sku} data-name={optionModel.name} data-brand={optionModel.brand} data-price={Math.abs(optionModel.netPrice).toFixed(2)} data-attribute={optionModel?.attributeValue}>
                                                        <OptionTile keyFor={optionModel.optionProductID} optionModel={optionModel}
                                                            allowQuantitySelection={categoryPanelModelData.allowQuantitySelection} allowMultipleSelection={categoryPanelModelData.allowMultipleSelection}
                                                            handleOptionSelected={handleOptionSelected} isIncompatible={false} imageLoaded={props.imageLoaded} loadingCategoryName={categoryPanelModelData.name} requiredLoadedCategories={props.requiredLoadedCategories}
                                                            isDisabled={!props.isViewModelUpdated || (categoryPanelModelData.id === 217 && optionModel.isSelected) || (props.categoryTouched.id === categoryPanelModelData.id && fetchingCategoryData) ? true : false} options={props.options} settings={ props.settings }
                                                            displayType={categoryPanelModelData.optionDisplayType} />
                                                    </div>
                                                )
                                        }
                                        { /* DEPRECATED SHOW MORE WERE HERE (21/5/25) */ }
                                    </div>
                            }

                            { /*----- INCOMPATIBLE OPTIONS -----*/ }
                            { 
                                // Only in expert mode, if the category has fetched all options, and there are 1+ incompatible options, and user hasn't already chosen to also show the incompatible ones, show the button that allows them to be displayed
                                props.isExpertMode && (categoryPanelModelData.isUpdated || props.categoryTouched.id === categoryPanelModelData.id) && (persistedIncompatibleItemsCount > 0 || (props.categoryTouched.id === categoryPanelModelData.id && incompatibleOptionsList.length > 0)) && !props.showIncompatible
                                ?
                                    <button className="cp-show-incompatible-button d-block me-auto border-0 bg-transparent mt-3 mt-sm-4 mb-0 ps-0 custom-color-light" onClick={handleShowIncompatibleOptions}>
                                        <span className="">{persistedIncompatibleItemsCount} incompatible items available. <span className="text-decoration-underline">Show options</span></span>
                                    </button>
                                :
                                    (props.isExpertMode && (categoryPanelModelData.isUpdated || props.categoryTouched.id === categoryPanelModelData.id) && (persistedIncompatibleItemsCount > 0 || (props.categoryTouched.id === categoryPanelModelData.id && incompatibleOptionsList.length > 0)) && props.showIncompatible)
                                    &&
                                        <button className="cp-show-incompatible-button d-block me-auto border-0 bg-transparent mt-3 mt-sm-4 mb-2 ps-0  custom-color-light" onClick={handleHideIncompatibleOptions}>
                                            <span className="">{persistedIncompatibleItemsCount} incompatible items being shown. <span className="text-decoration-underline">Hide options</span></span>
                                        </button>
                            }
                            {
                                // Only in expert mode, if the category has fetched all options, and user has chosen to also show the incompatible ones, show them
                                (props.isExpertMode && categoryPanelModelData.isUpdated && props.showIncompatible)
                                ?
                                    <div className={"row" + getRowColsClass(site, categoryPanelModelData.optionDisplayType)}>
                                        {
                                            incompatibleOptionsList.map(optionModel =>
                                                <div key={"div_" + optionModel.optionProductID} className="ot-container col">
                                                    <OptionTile keyFor={optionModel.optionProductID} optionModel={optionModel}
                                                        allowQuantitySelection={categoryPanelModelData.allowQuantitySelection} allowMultipleSelection={categoryPanelModelData.allowMultipleSelection}
                                                        handleOptionSelected={handleOptionSelected} isIncompatible={true} imageLoaded={props.imageLoaded} loadingCategoryName={categoryPanelModelData.name} requiredLoadedCategories={props.requiredLoadedCategories}
                                                        isDisabled={(!props.isViewModelUpdated || (categoryPanelModelData.id === 217 && optionModel.isSelected)) ? true : false} options={props.options} settings={props.settings} 
                                                        displayType={categoryPanelModelData.optionDisplayType} />
                                                </div>
                                            )
                                        }
                                    </div>
                                :
                                (props.isExpertMode && !categoryPanelModelData.isUpdated && props.showIncompatible)
                                &&
                                    <div className="d-flex justify-content-center align-items-center mt-3" role="status" style={{ height: "5.625rem" }}>
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            {
                (props.bannerJSON?.imageUrl && props.settings?.imageBaseUrl)
                &&
                    <>
                        <button className="border-0 p-0 mb-3" 
                                {...props.bannerJSON.description ? { 'data-bs-toggle': 'offcanvas', 'data-bs-target': `#offcanvasBannerInfo_${categoryPanelModelData.id}`, 'aria-controls': `#offcanvasBannerInfo_${categoryPanelModelData.id}` } : {}}
                                type="button" onClick={() => { Utils.navigateToPage(props.bannerJSON.navUrl ?? null) } }
                        >
                            <img src={props.settings.imageBaseUrl + props.bannerJSON.imageUrl + "?scale=both"} className="img-fluid" alt="Banner Info"></img>
                        </button>

                        {
                            props.bannerJSON.description
                            &&
                                <div className="offcanvas offcanvas-end" tabIndex="-1" id={"offcanvasBannerInfo_" + categoryPanelModelData.id} aria-labelledby={"offcanvasBannerInfo_" + categoryPanelModelData.id}>
                                    <div className="offcanvas-header p-3 pb-2 p-md-5 pb-md-3">
                                        <div className={!props.bannerJSON.title ? "d-none" : ""}>
                                            <h1 className="offcanvas-title mb-2 me-2 me-sm-3" dangerouslySetInnerHTML={{ __html: props.bannerJSON.title }} />
                                        </div>
                                        <button type="button" className={"offcanvas-close-button btn-close me-1" + (!props.bannerJSON.title ? " ms-auto" : "")} data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                    </div>
                                    <div className="offcanvas-body d-flex flex-column pt-2 px-3 px-md-5 pb-5">
                                        <span dangerouslySetInnerHTML={{ __html: props.bannerJSON.description }} ></span>
                                    </div>
                                </div>
                        }
                    </>
                        
            }
        </>
    );
}
